// src/features/locker-assignments/components/ui/AssignmentStatusChip.tsx
import React from 'react';
import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import {
  CheckCircle,
  Schedule,
  Archive,
  HourglassEmpty,
} from '@mui/icons-material';
import { AssignmentStatus, getAssignmentStatusColor, getAssignmentStatusLabel } from '../../types';

export interface AssignmentStatusChipProps {
  status: AssignmentStatus;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

export const AssignmentStatusChip: React.FC<AssignmentStatusChipProps> = ({
  status,
  size = 'small',
  showIcon = true,
}) => {
  const translate = useTranslate();
  
  const getIcon = () => {
    switch (status) {
      case AssignmentStatus.Active:
        return <CheckCircle />;
      case AssignmentStatus.Pending:
        return <HourglassEmpty />;
      case AssignmentStatus.Archived:
        return <Archive />;
      default:
        return <Schedule />;
    }
  };

  return (
    <Chip
      label={translate(getAssignmentStatusLabel(status))}
      color={getAssignmentStatusColor(status)}
      size={size}
      icon={showIcon ? getIcon() : undefined}
      sx={{ fontWeight: 500 }}
    />
  );
};